const baseState = {
    snapshotList: [],
    modifyingDateTimeArray: [],
    selectedSnapshotIndex: 0,
    currentUserState: null
}

const userHistoryReducer = (state = baseState, { type, payload }) => {

    switch (type) {
    	case "SET_USER_SNAPSHOT_LIST": {
			return {
				...state,
				snapshotList: payload
			}
		}

		case "CLEAR_USER_SNAPSHOT_LIST": {
			return {
				...state,
				usersList: []
			}
		}

		case "SET_USER_MODIFYINGDATE_TIME_ARRAY": {
            return {
                ...state,
                modifyingDateTimeArray: payload
            }
        }

        case "SET_USER_SELECTED_SNAPSHOT_INDEX": {
            return {
                ...state,
                selectedSnapshotIndex: payload
            }
        }

        case "SET_CURRENT_USER_STATE": {
			return {
				...state,
				currentUserState: payload
			}
		}

        default:
            return state;
    }
}

export default userHistoryReducer